module.exports = (parcelRequire.load("96AxF")).then(() => parcelRequire('cr3fk'));